var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.41 22.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.97,16.35c-2.33-.03-4.68-.13-6.96-.6s-4.52-1.36-6.34-2.84c-1.2-.98-2.26-2.37-2.16-3.91.09-1.3.99-2.42,1.99-3.26,1.74-1.47,3.88-2.41,6.08-3,3.78-1.03,7.8-1.43,11.7-1.03,3.5.36,6.99,1.36,9.91,3.33.97.66,1.91,1.46,2.39,2.53.84,1.86.11,4.13-1.27,5.63s-3.29,2.38-5.18,3.17c1.56-.62,3.14-1.25,4.51-2.23,2.73-1.97,3.77-5.16,1.64-8.03-2.3-3.09-6.46-4.55-10.07-5.38-4.34-.99-8.92-.95-13.26.01-1.23.27-2.44.62-3.62,1.05C4.25,2.91.48,5.22.04,8.79c-.3,2.47,1.23,4.83,3.15,6.41,2.02,1.66,4.49,2.7,7.03,3.35s5.15.93,7.75,1.2c0,.96,0,1.93,0,2.89,2.65-1.58,5.31-3.16,7.96-4.75l-7.96-4.61c0,1.02,0,2.05,0,3.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateWhite);
export default __webpack_public_path__ + "static/media/rotate_white.221ef40ad822345d4533dbba5dbf19da.svg";
export { ForwardRef as ReactComponent };